import React from 'react';
import { Sizes } from '../constants.js';

var MinusIcon = function MinusIcon(_ref) {
  var fillColor = _ref.fillColor,
      size = _ref.size;

  if (size === Sizes.Small) {
    return /*#__PURE__*/React.createElement("svg", {
      width: "10",
      height: "2",
      viewBox: "0 0 10 2",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M9 3.49691e-07C9.55228 3.73832e-07 10 0.447716 10 1C10 1.55229 9.55228 2 9 2L1 2C0.447716 2 -2.41411e-08 1.55228 0 1C2.41411e-08 0.447715 0.447715 -2.41411e-08 1 0L9 3.49691e-07Z",
      fill: fillColor
    }));
  }

  return /*#__PURE__*/React.createElement("svg", {
    width: "10",
    height: "2",
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 0.166992C8.79324 0.166992 9.16634 0.540089 9.16634 1.00033C9.16634 1.46056 8.79324 1.83366 8.33301 1.83366L1.66634 1.83366C1.2061 1.83366 0.833008 1.46056 0.833008 1.00033C0.833008 0.540088 1.2061 0.166992 1.66634 0.166992L8.33301 0.166992Z",
    fill: fillColor
  }));
};

export { MinusIcon as default };
